import {sendViewEvent} from "../../util/Ga4EventUtil";

/**
 * ブラウザの戻るボタンを押したときに再リダイレクトが走らないよう、履歴を残さずリダイレクトする
 */
export function nextReplace(next, path) {
    next({
        path: path,
        options: {
            replace: true
        }
    })
}

/**
 * 遷移する際にApp+WebにNavigationGuard通過ずみのアクセスとしてviewを送信する
 * @param next 画面遷移実行関数（ナビゲーションガード解決関数）
 * @param path 遷移先のパス（App+Webへのログデータ記録用）
 */
export function nextWithPageView(next, path) {
    sendViewEvent(path)
    next()
}